import {Socket} from 'ngx-socket-io';
import {Subscription} from 'rxjs/internal/Subscription';
import {NotificationsSystemBase} from '../models/notifications-system-base.model';

export interface NotifyWithSoundInterface {
  soundPath: string;
  soundSubscription: Subscription;
}

export abstract class NotificationWithSoundAlerts extends NotificationsSystemBase implements NotifyWithSoundInterface {
  soundPath: string;
  soundSubscription: Subscription;

  constructor( type: string, notificationsService: Socket) {
    super(type, notificationsService);
  }

  subscribeToSoundAlert() {
    if (this.soundSubscription) {
      this.unsubscribeToSoundAlert();
    }
    this.soundSubscription = this.notifications$
      .asObservable()
      .subscribe(() => {
        new Audio(this.soundPath).play();
      });
  }

  unsubscribeToSoundAlert() {

    this.soundSubscription.unsubscribe();
  }
}
